import Header from "components/bible/Header";

function Bible() {
  return (
    <>
      <Header />
    </>
  );
}

export default Bible;
